export default __webpack_public_path__ + "static/media/full_white.0f181716.svg";